import { render, staticRenderFns } from "./chatLog.vue?vue&type=template&id=53d480fa&scoped=true&"
import script from "./chatLog.vue?vue&type=script&lang=js&"
export * from "./chatLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d480fa",
  null
  
)

export default component.exports